jQuery($ => {
  class AdminTooltipField {
    constructor(element) {
      this._         = element;
      this._element  = $(element);
      this._image    = this._element.find('.m-image-tooltips-module');
      this._tooltip  = this._element.find('.m-image-tooltips-module__item');

      this.position = {};

      this.init(); 
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger( 'init', this );
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      $(document).on('mousemove', this.handleIsDragging);
      $(document).on('mouseup', this.handleStopDragging);

      this._image.on('mousedown', this.handleImageClick);
      this._image.on('mousedown', this.handleStartDragging);
    }

    getLeftPercent(left) {
      let percent = (parseFloat(left) / this._image.width()) * 100;
      return `${percent}%`;
    }

    getTopPercent(top) {
      let percent = (parseFloat(top) / this._image.height()) * 100;
      return `${percent}%`;
    }

    handleStartDragging = () => {
      if ( this._element.hasClass('o-admin-tooltip-field--dragging') ) return;
      this._element.addClass('o-admin-tooltip-field--dragging');
    }

    handleStopDragging = () => {
      if ( !this._element.hasClass('o-admin-tooltip-field--dragging') ) return;
      this._element.removeClass('o-admin-tooltip-field--dragging');
      this.saveTooltip();
    }

    handleImageClick = event => {
      let offset = this._image.offset(),
          top    = event.pageY - offset.top,
          left   = event.pageX - offset.left;

      this.setTooltipPosition(this.getTopPercent(top), this.getLeftPercent(left));
      this.setTooltipStyle();
      this.saveTooltip();
    }

    handleIsDragging = event => {
      if ( !this._element.hasClass('o-admin-tooltip-field--dragging') ) return;

      let height  = this._image.height(),
          width   = this._image.width(),
          offset  = this._image.offset(),
          left    = (event.pageX - offset.left),
          top     = (event.pageY - offset.top);

      if (left > width) {
          left = width;
      } else if (left < 0) {
          left = 0;
      }

      if (top > height) {
          top = height;
      } else if (top < 0) {
          top = 0;
      }

      this.setTooltipPosition(this.getTopPercent(top), this.getLeftPercent(left));
      this.setTooltipStyle();
    }

    setTooltipPosition = (top, left) => {
      this.position = {
        top,
        left,
      }
    }

    setTooltipStyle = () => {
      this._tooltip.css(this.position);
    }

    saveTooltip = () => {
      this._element.trigger('setPosition', this);
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.admin_tooltip_field = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].admin_tooltip_field = new AdminTooltipField(_[i], opt);
      else
        ret = _[i].admin_tooltip_field[opt].apply(_[i].admin_tooltip_field, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-admin-tooltip-field').admin_tooltip_field();
});